import classNames from 'classnames';
import camelCase from 'lodash/camelCase';

import PlaceholderText from '../partials/PlaceholderText';
import CardTitle from '../typography/CardTitle';
import AuthorHorizontalCard from './AuthorHorizontalCard';
import BrandHorizontalCard from './BrandHorizontalCard';
import CollectionHorizontalCard from './CollectionHorizontalCard';
import DocumentHorizontalCard from './DocumentHorizontalCard';
import HorizontalCard from './HorizontalCard';

import styles from '../../styles/cards/timeline-horizontal-card.module.css';

interface TimelineHorizontalCardProps {
    label?: string;
    url?: string;
    document?: Document;
    collection?: Collection;
    author?: Author;
    brand?: Brand;
    onClick?: () => void;
    theme?: 'box' | 'menu' | null;
    placeholder?: boolean;
    className?: string;
}

function TimelineHorizontalCard({
    label = null,
    url = null,
    document = null,
    collection = null,
    brand = null,
    author = null,
    onClick = null,
    theme = null,
    placeholder = false,
    className = null,
    ...props
}: TimelineHorizontalCardProps) {
    const isBox = theme !== null && theme.indexOf('box') === 0;

    const path = url !== null ? url.replace(/^https?:\/\/[^/]+\//, '/') : null;

    if (document !== null) {
        return (
            <DocumentHorizontalCard
                {...document}
                theme={theme}
                {...props}
                className={classNames([styles.container, className])}
            />
        );
    }

    if (author !== null) {
        return (
            <AuthorHorizontalCard
                {...author}
                theme={theme}
                {...props}
                className={classNames([styles.container, className])}
            />
        );
    }

    if (collection !== null) {
        return (
            <CollectionHorizontalCard
                {...collection}
                theme={theme}
                {...props}
                className={classNames([styles.container, className])}
            />
        );
    }

    if (brand !== null) {
        const { handle: brandHandle } = brand;
        return (
            <BrandHorizontalCard
                {...brand}
                shortDescription={null}
                label={label}
                theme={theme}
                {...props}
                className={classNames([
                    styles.container,
                    styles.brand,
                    styles[brandHandle],
                    className,
                ])}
            />
        );
    }

    return (
        <HorizontalCard
            href={path}
            onClick={onClick}
            className={classNames([
                styles.container,
                {
                    [styles.box]: isBox,
                    [styles.menu]: theme === 'menu',
                },
                styles[camelCase(theme)],
                className,
            ])}
            labelClassName={styles.label}
        >
            <CardTitle className={styles.title} placeholder={placeholder}>
                {label || path}
            </CardTitle>
        </HorizontalCard>
    );
}

export default TimelineHorizontalCard;
